import getFulfilmentIds from "../../../../../../getFulfilmentIds";
import getSingleItemEvarsString from "./getSingleItemEvarsString";
import getValueOrEmptyString from "./getValueOrEmptyString";
import getItemId from "../../../../../../getItemId";

const getSingleItemProductString = ({
  productId,
  variantId,
  quantity,
  price,
  source,
  seller,
  isProductInStock,
  isRestockingSoon,
  earlyAccess
}) => {
  const { sourceId, sellerId } = getFulfilmentIds({ source, seller });

  const itemIdString = getItemId({ variantId, productId });
  const quantityString = getValueOrEmptyString(quantity);
  const priceString = getValueOrEmptyString(price);
  const eVarsString = getSingleItemEvarsString({
    sourceId,
    sellerId,
    isProductInStock,
    isRestockingSoon,
    earlyAccess
  });

  return `;${itemIdString};${quantityString};${priceString};;${eVarsString}`;
};

export default getSingleItemProductString;
